import React, {
  useState,
  useCallback,
  useReducer,
  useEffect,
  useRef,
} from 'react';
import {
  // Icon,
  Divider,
  Radio,
  CheckboxProps,
  // Message,
  // Input,
  // Button,
  // Label,
  // Popup,
  // SemanticICONS,
  DropdownProps,
} from 'semantic-ui-react';
// import { SignInButton } from '../TopBar/TopBar';
// import { getCurrentSettings, updateSettings } from './LocalSettings';
import axios from 'axios';
import { serverPath } from '../../utils';
import { PermanentRoomModal } from '../Modal/PermanentRoomModal';
import firebase from 'firebase/compat/app';
import { Socket } from 'socket.io-client';
// import { HexColorPicker } from 'react-colorful';
import { getJwtToken } from '../../utils/auth';
import { sendInvite } from '../../api/user';
import HostLeaveDialog from '../HostLeaveDialog/HostLeaveDialog';

// const defaultRoomTitleColor = '#FFFFFF';
// const roomTitleMaxCharLength = 50;
// const roomDescriptionMaxCharLength = 120;

interface SettingsTabProps {
  hide: boolean;
  user: firebase.User | User;
  roomLock: string;
  setRoomLock: (lock: boolean) => Promise<void>;
  socket: Socket;
  isSubscriber: boolean;
  roomId: string;
  owner: string | undefined;
  setOwner: (owner: string) => void;
  vanity: string | undefined;
  setVanity: (vanity: string) => void;
  roomLink: string;
  password: string | undefined;
  setPassword: (password: string) => void;
  isChatDisabled: boolean;
  setIsChatDisabled: (disabled: boolean) => void;
  clearChat: () => void;
  roomTitle: string | undefined;
  setRoomTitle: (title: string) => void;
  roomDescription: string | undefined;
  setRoomDescription: (desc: string) => void;
  roomTitleColor: string | undefined;
  setRoomTitleColor: (color: string) => void;
  mediaPath: string | undefined;
  setMediaPath: (path: string) => void;
  participants: User[];
  setMedia: (e: any, data: DropdownProps) => void;
  settings: RoomSettings;
  getRoomState: () => void;
  nameMap: StringDict;
  pictureMap: StringDict;
  coHosts: string[];
  handleClickOnNo: () => void;
  watchPartyDetails: IWatchpartyDetails | undefined;
  showAdminLeaveModal: boolean;
  handleToggleAdminLeaveModal: () => void;
}

export const SettingsTab = ({
  hide,
  user,
  roomLock,
  setRoomLock,
  socket,
  isSubscriber,
  owner,
  vanity,
  setVanity,
  roomLink,
  password,
  setPassword,
  isChatDisabled,
  setIsChatDisabled,
  clearChat,
  roomTitle,
  roomDescription,
  roomTitleColor,
  mediaPath,
  setMediaPath,
  participants,
  setMedia,
  settings,
  roomId,
  getRoomState,
  nameMap,
  pictureMap,
  setOwner,
  coHosts,
  handleClickOnNo,
  watchPartyDetails,
  showAdminLeaveModal,
  handleToggleAdminLeaveModal,
}: SettingsTabProps) => {
  // const [showSharModal, setShowSharModal] = useState<boolean>(false);
  const isFirstTimeLoading = useRef(true);
  // const [updateTS, setUpdateTS] = useState(0);
  const [permModalOpen, setPermModalOpen] = useState(false);
  // const [validVanity, setValidVanity] = useState(true);
  // const [validVanityLoading, setValidVanityLoading] = useState(false);
  // const [adminSettingsChanged, setAdminSettingsChanged] = useState(false);
  // const [copied, setCopied] = useState(false);
  // const [roomTitleInput, setRoomTitleInput] = useState<string | undefined>(
  //   undefined
  // );

  const [peopleAllowed, setPeopleAllowed] = useReducer(
    (prev: RoomSettings, next: RoomSettings) => {
      if (next.isFriendAllowed || next.isFanAllowed) {
        return { ...prev, ...next, isEveryoneAllowed: false };
      }

      if (next.isEveryoneAllowed) {
        return {
          ...prev,
          ...next,
          isFanAllowed: false,
          isFriendAllowed: false,
          isEveryoneAllowed: watchPartyDetails!.target_type.includes(
            'Individuals'
          )
            ? false
            : true,
        };
      }
      return { ...prev, ...next };
    },
    {
      isFanAllowed: false,
      isFriendAllowed: false,
      isEveryoneAllowed: true,
      ...settings,
    }
  );
  const [isUpdatingRoom, setIsUpdatingRoom] = useState(false);

  // const [roomDescriptionInput, setRoomDescriptionInput] = useState<
  //   string | undefined
  // >(undefined);
  // const [roomTitleColorInput, setRoomTitleColorInput] = useState<
  //   string | undefined
  // >('');

  // const handleRedirect = useCallback((getLink: string) => {
  //   window.open(getLink, '_blank', 'noopener');
  // }, []);

  useEffect(() => {
    if (settings) {
      setPeopleAllowed(settings);
    }
  }, [settings]);
  useEffect(() => {
    if (isFirstTimeLoading.current) {
      isFirstTimeLoading.current = false;
    }
  }, []);

  // const setRoomState = useCallback(
  //   async (data: any) => {
  //     const token = getJwtToken();

  //     socket.emit('CMD:setRoomState', {
  //       uid: user?.uid,
  //       token,
  //       ...data,
  //     });
  //   },
  //   [socket, user]
  // );
  // const setRoomOwner = useCallback(
  //   async (data: any) => {
  //     const token = getJwtToken();

  //     await socket.emit('CMD:setRoomOwner', {
  //       uid: user?.uid,
  //       token,
  //       ...data,
  //     });
  //   },
  //   [socket, user]
  // );
  // const checkValidVanity = useCallback(
  //   async (input: string) => {
  //     if (!input) {
  //       setValidVanity(true);
  //       return;
  //     }
  //     setValidVanity(false);
  //     setValidVanityLoading(true);
  //     const response = await axios.get(serverPath + '/resolveRoom/' + input);
  //     const data = response.data;
  //     setValidVanityLoading(false);
  //     if (
  //       data &&
  //       data.vanity &&
  //       data.vanity !== roomLink.split('/').slice(-1)[0]
  //     ) {
  //       // Already exists and doesn't match current room
  //       setValidVanity(false);
  //     } else {
  //       setValidVanity(true);
  //     }
  //   },
  //   [setValidVanity, roomLink]
  // );
  // const disableLocking =
  //   !Boolean(user) || Boolean(roomLock && roomLock !== user?.uid);
  // const disableOwning = !Boolean(user) || Boolean(owner && owner !== user?.uid);

  const updateRoom = async () => {
    setIsUpdatingRoom(true);
    const token = getJwtToken();

    try {
      await axios.put(
        `${serverPath}/updateRoom?uid=${user?.uid}&token=${token}&roomId=${roomId}`,
        { settings: peopleAllowed }
      );
      getRoomState();
    } catch (error) {
      console.log(error);
    } finally {
      setIsUpdatingRoom(false);
    }
  };

  useEffect(() => {
    if (!isFirstTimeLoading.current) {
      updateRoom();
    }
  }, [peopleAllowed]);

  // const getParticipants = () => {
  //   if (participants.length === 1 && participants[0]?.uid === owner) {
  //     return <p>The host is present</p>;
  //   }
  //   return (
  //     <p>
  //       {participants.length} {participants.length === 1 ? 'person' : 'people'}{' '}
  //       joined
  //     </p>
  //   );
  // };

  // const redirectToWatchPartyDomain = () => {
  //   if (process.env.REACT_APP_DMDB_DOMAIN) {
  //     window.location.href = process.env.REACT_APP_DMDB_DOMAIN;
  //   } else {
  //     window.location.href = 'https://www.dmdb.com';
  //   }
  // };

  // const isOwner = owner === user?.uid;

  // const handleCopyInviteLink = () => {
  //   navigator.clipboard.writeText(window.location.href);
  //   setCopied(true);

  //   setTimeout(() => {
  //     setCopied(false);
  //   }, 2000);
  // };

  return (
    <div className={`mt-6 ${hide ? 'hidden' : 'block'}`}>
      {permModalOpen && (
        <PermanentRoomModal
          closeModal={() => setPermModalOpen(false)}
        ></PermanentRoomModal>
      )}
      {owner === user?.uid && (
        <>
          <h5 className="text-[20px] text-gradient-blue inline-block my-6 font-semibold">
            People Allowed
          </h5>
          <div className="radio-bg mb-6">
            <NewSettingRow
              toggle
              icon={''}
              name={`Friends`}
              description=""
              checked={Boolean(peopleAllowed.isFriendAllowed)}
              disabled={
                isUpdatingRoom ||
                (owner !== user?.uid && !coHosts.includes(user.uid ?? '')) ||
                watchPartyDetails!.target_type.includes('Individuals')
              }
              // disabled={disableLocking && disableOwning}
              onChange={(_e, data) => {
                setPeopleAllowed({ isFriendAllowed: Boolean(data.checked) });
                sendInvite(
                  roomId,
                  data.checked ? ['Friends'] : [],
                  [],
                  [],
                  [],
                  []
                );
              }}
            />
          </div>
          <div className="radio-bg mb-6">
            <NewSettingRow
              toggle
              icon={''}
              name={`Fans`}
              description=""
              checked={Boolean(peopleAllowed.isFanAllowed)}
              disabled={
                isUpdatingRoom ||
                (owner !== user?.uid && !coHosts.includes(user.uid ?? '')) ||
                watchPartyDetails!.target_type.includes('Individuals')
              }
              // disabled={disableLocking && disableOwning}
              onChange={(_e, data) => {
                setPeopleAllowed({ isFanAllowed: Boolean(data.checked) });
                sendInvite(
                  roomId,
                  data.checked ? ['Fans'] : [],
                  [],
                  [],
                  [],
                  []
                );
              }}
            />
          </div>
          <div className="radio-bg">
            <NewSettingRow
              toggle
              icon={''}
              name={`Anyone`}
              description=""
              checked={Boolean(peopleAllowed.isEveryoneAllowed)}
              disabled={
                isUpdatingRoom ||
                (owner !== user?.uid && !coHosts.includes(user.uid ?? '')) ||
                watchPartyDetails!.target_type.includes('Individuals')
              }
              // disabled={disableLocking && disableOwning}
              onChange={(_e, data) => {
                setPeopleAllowed({
                  isEveryoneAllowed: Boolean(data.checked),
                });
                sendInvite(
                  roomId,
                  data.checked ? ['Block Party'] : [],
                  [],
                  [],
                  [],
                  []
                );
              }}
            />
          </div>
        </>
      )}
      <h5 className="text-[20px] text-gradient-blue inline-block mt-6 font-semibold">
        Party Link
      </h5>
      <p className="text-[20px] my-3 text-[#AE8A27]">
        Share the link with others and then everyone can watch together. They’ll
        need to join from web browser on their computer.
        <a
          className="mt-3 break-all text-[20px] text-gradient-blue inline-block hover:opacity-65"
          href={window.location.href}
        >
          {window.location.href}
        </a>
      </p>
      {/* <div className="copysharebutton flex gap-3">
        <button
          className="gradient-outline-btn text-[#b069fe] flex items-center gap-1 rounded-lg py-2 px-4 text-[18px] relative duration-200  hover:opacity-70"
          onClick={handleCopyInviteLink}
        >
          <i className="ri-file-copy-fill"></i>
          <span className="max-sm:hidden">Copy Link</span>
          {copied && (
            <div className="absolute left-1/2 -translate-x-1/2 mt-2 px-4 py-2 bg-white -bottom-8 text-black text-sm rounded-md shadow-lg z-10">
              Copied!
            </div>
          )}
        </button>

        <button
          onClick={() => {
            setShowSharModal((prev) => !prev);
          }}
          className="gradient-outline-btn text-[#b069fe] flex items-center gap-1 rounded-lg py-2 px-4 text-[18px] relative duration-200  hover:opacity-70"
        >
          <i className="ri-share-fill"></i>
          <span className="max-sm:hidden">Share Link</span>
        </button>
      </div>

      <button
        className="w-full gradient-outline-btn text-[18px] px-2 py-4 rounded-lg duration-200  hover:opacity-70"
        onClick={async () => {
          if (isOwner) {
            if (
              Array.from(new Set(participants.map((p) => p.uid))).map(
                (uniqueUid) => {
                  return participants.find((i) => i.uid === uniqueUid);
                }
              ).length !== 1
            ) {
              setShowAdminLeaveModal(true);
            } else {
              await endParty(roomId);
              socket.emit('CMD:leaveVideo');
              handleClickOnNo();
            }
          } else {
            socket.emit('CMD:leaveVideo');
            redirectToWatchPartyDomain();
          }
        }}
      >
        <span>
          {isOwner || coHosts.includes(user?.uid ?? '') ? 'End' : 'Leave'} Watch
          Party
        </span>
      </button> */}
    </div>
  );
};

const NewSettingRow = ({
  icon,
  name,
  description,
  checked,
  disabled,
  onChange,
  content,
  subOnly,
  helpIcon,
  rightContent,
  toggle,
}: {
  icon: string;
  name: string;
  description?: React.ReactNode;
  checked?: boolean;
  disabled: boolean;
  updateTS?: number;
  onChange?: (e: React.FormEvent, data: CheckboxProps) => void;
  content?: React.ReactNode;
  subOnly?: boolean;
  helpIcon?: React.ReactNode;
  rightContent?: React.ReactNode;
  toggle: boolean;
}) => {
  return (
    <React.Fragment>
      <div>
        <div className="flex items-center">
          <h5 className="text-[18px] font-semibold text-gradient-blue inline-block">
            {name}
          </h5>
          {toggle && (
            <>
              {/* <div className="field">
                <div className="ui toggle checkbox">
                  <input type="checkbox" name="checboxname" id="checboxname" value="any" />
                  <label className="coloring red">any label</label>
                </div>
              </div> */}
              <Radio
                toggle
                checked={checked}
                disabled={disabled}
                onChange={onChange}
                className="ml-auto !min-h-8"
              />
            </>
          )}
        </div>
        {content}
      </div>
    </React.Fragment>
  );
};
